import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useI18n } from '../../context/I18nContext';
import { authColors, shadows, neutralColors } from '../../styles/colors';
import PublicHeader from '../../components/layout/PublicHeader';
import PublicFooter from '../../components/layout/PublicFooter';
import { Home, ArrowLeft } from 'lucide-react';

const NotFoundPage: React.FC = () => {
  const { user } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();

  return (
    <div className={`min-h-screen flex flex-col ${authColors.backgroundGradient}`}>
      <PublicHeader />
      
      <main className="flex-grow flex items-center justify-center px-4 py-16">
        <div className="max-w-2xl w-full text-center">
          <div className="mb-8">
            <h1 className="text-9xl font-bold bg-gradient-to-r from-blue-500 via-blue-600 to-cyan-600 bg-clip-text text-transparent mb-4">404</h1>
            <h2 className={`text-3xl font-bold ${neutralColors.grayTextHover} mb-4`}>
              {t('notFound.title')}
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              {t('notFound.description')}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate(-1)}
              className={`inline-flex items-center justify-center px-6 py-3 border ${neutralColors.grayBorder} rounded-lg ${neutralColors.grayTextDark} bg-white hover:bg-gray-50 transition-colors font-medium`}
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              {t('notFound.goBack')}
            </button>
            
            {user ? (
              <Link
                to="/app"
                className={`inline-flex items-center justify-center px-6 py-3 rounded-lg text-white font-medium ${authColors.primaryGradient} ${shadows.medium} hover:shadow-lg transition-all`}
              >
                <Home className="w-5 h-5 mr-2" />
                {t('notFound.goToDashboard')}
              </Link>
            ) : (
              <Link
                to="/"
                className={`inline-flex items-center justify-center px-6 py-3 rounded-lg text-white font-medium ${authColors.primaryGradient} ${shadows.medium} hover:shadow-lg transition-all`}
              >
                <Home className="w-5 h-5 mr-2" />
                {t('notFound.goToHome')}
              </Link>
            )}
          </div>
        </div>
      </main>

      <PublicFooter />
    </div>
  );
};

export default NotFoundPage;

